import moment from 'moment'

export default class Storage {
  static set(key, value) {
    if (window.localStorage) {
      window.localStorage.setItem(key, value)
    }
    return false
  }

  static get(key) {
    if (window.localStorage) {
      return window.localStorage.getItem(key) || false
    }
    return false
  }

  static remove(key) {
    if (window.localStorage) {
      return window.localStorage.removeItem(key) || false
    }
    return false
  }

  static setDate(date) {
    if (typeof date === 'undefined') {
      return
    }

    this.set('saved_date', date.start_date)
    this.set('created_at', moment().format('X'))
  }

  static getDate(dates) {
    let previous = this.get('created_at')
    if (previous) {
      const isValid = moment(previous, 'X').isAfter(moment().subtract(3, 'h'))

      if (!isValid) {
        this.setDate(dates[0])
        return 0
      }
    }

    let date = this.get('saved_date')
    if (date) {
      for (let i = 0; i < dates.length; i++) {
        if (dates[i].start_date === date) {
          return i
        }
      }
    }

    this.setDate(dates[0])
    return 0
  }
}
